// extracted by mini-css-extract-plugin
export default {"wrapper":"Paragraph_wrapper__1TjpO","small":"Paragraph_small__Z9HoC"};